import axios, { AxiosResponse } from 'axios'

import gql from '@js/api/utils/gql'
import { env } from '@js/utils/env'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerLicense } from '@js/api/types/customer/CustomerLicense'

interface UpsertCustomerLicensePayload {
  customerId: number
  licenseType: string
  licenseState: string
  licenseNumber?: string | null
  licenseId: number | null
  license_profession_id: number
}

interface upsertCustomerLicenseResponse {
  data: {
    wceiUpsertCustomerLicense: CustomerLicense
  }
  errors?: [{ message: string }]
}

export const upsertCustomerLicenseMutation = gql`
  mutation(
    $licenseId: Int,
    $licenseNumber: String,
    $licenseType: String!,
    $licenseState: String!,
    $license_profession_id: Int!
  ) {
    wceiUpsertCustomerLicense(
      input: { 
        license_id: $licenseId, 
        license_number: $licenseNumber,
        license_type: $licenseType,
        license_state: $licenseState,
        license_profession_id: $license_profession_id
      }
    ) {
      customer_id
      license_id
      license_number
      license_state
      license_type
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const upsertCustomerLicense = async (payload: UpsertCustomerLicensePayload): Promise<CustomerLicense> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<upsertCustomerLicenseResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: upsertCustomerLicenseMutation,
      variables: payload,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.wceiUpsertCustomerLicense
}
